namespace $.$$ {
	
	$mol_style_define( $hyoo_dnd_spell_config, {
		
		flex: {
			basis: '40rem',
		},
		
		Body_content: {
			gap: $mol_gap.block,
		},
		
	} )
	
}
